import axios from '../axios';
import config from "../../../config";

export default {
    /**
     *
     * @param token
     * @return {Promise<*>}
     */
    getRedirectLink(token) {
        return axios.get(config.host + '/public/redirect', {
            params: {
                Token: token
            }
        }).then(resp => resp.data.Data.Link)
    }
}
